export const EULER = 'EULER';
export const FCOSE = 'FCOSE';
export const AVSDF = 'AVSDF';
export const KLAY = 'KLAY';


export const STIX_GRAPH = "STIX_GRAPH";
export const CONCEPT_NETWORK_STIX = "CONCEPT_NETWORK_STIX";
export const CONCEPT_NETWORK_TOPIC_MODEL = "CONCEPT_NETWORK_TOPIC_MODEL";
export const CONCEPT_NETWORK_CONCEPT_MODEL = "CONCEPT_NETWORK_CONCEPT_MODEL";